module.exports = __webpack_public_path__ + "img/bitcoin3.90d977ae.png";